import CommentItem from '../Domain/CommentItem.js';
import AuthService from './authService.js';

class CommentService 
{
    
    // An entity is identified either by an int entityId or by a Guid guidEntityId (never both).
    static GetCommentsByEntityTypeIdAndEntityId(entityTypeId, entityId, guidEntityId)
    {
        let url = `/api/Comment/GetComments/?entityTypeId=${entityTypeId}&clearCache=false`;
        if (guidEntityId !== undefined && guidEntityId !== null && guidEntityId !== '') {
          url += `&guidEntityId=${guidEntityId}`;
        } else {
          url += `&entityId=${entityId}`;
        }
        return AuthService.getInstance().CallBackendFunction(url);
    }

    static SaveComment(entityTypeId, entityId, newComment, guidEntityId)
    {
        const payload = {
          EntityTypeId: entityTypeId,
          NewComment: newComment,
        };
        if (guidEntityId !== undefined && guidEntityId !== null && guidEntityId !== '') {
          payload.GuidEntityId = guidEntityId;
        } else {
          payload.EntityId = entityId;
        }
        return AuthService.getInstance()
            .CallBackendFunctionPost("/api/Comment/SaveComments/", JSON.stringify(payload));
    }

    static ConvertDBItem(items)
    {
        const convertedItems = [];

        if (items !== null) {
          items.forEach((item) => {
            const newItem = new CommentItem(item);
            convertedItems.push(newItem);
          });
        }   
        
        return convertedItems;
    }

    


}

export default CommentService;